import { z } from 'zod'

import { AlertsPayload } from './types'

const emptyToUndefined = (value: unknown) => (value === null || value === '' ? undefined : value)
const companyValueToUndefined = (value: unknown) =>
  value === null || value === '' || value === 'my' ? undefined : value

export const schema = z.object({
  uploadsType: z.preprocess(emptyToUndefined, z.string().optional()),
  uploadsCompanyID: z.preprocess(companyValueToUndefined, z.number().int().nonnegative().optional()),
  uploadsPage: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  uploadsSize: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  uploadsSortBy: z.preprocess(emptyToUndefined, z.string().optional()),
  uploadsSortDesc: z.preprocess(emptyToUndefined, z.boolean().optional().nullable()),
  applicationsPage: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  applicationsSize: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  applicationsSortBy: z.preprocess(emptyToUndefined, z.string().optional()),
  applicationsSortDesc: z.preprocess(emptyToUndefined, z.boolean().optional().nullable()),
  CTRsPage: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  CTRsSize: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  bsaBatchesPage: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  bsaBatchesSize: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  SARsPage: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  SARsSize: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  quarterlyAnalyticsPage: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  quarterlyAnalyticsSize: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  quarterlyAnalyticsCompanyID: z.preprocess(companyValueToUndefined, z.number().int().nonnegative().optional()),
  monthlyAnalyticsPage: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  monthlyAnalyticsSize: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  monthlyAnalyticsCompanyID: z.preprocess(companyValueToUndefined, z.number().int().nonnegative().optional()),
  annualReviewsPage: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  annualReviewsSize: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  annualReviewsCompanyID: z.preprocess(companyValueToUndefined, z.number().int().nonnegative().optional()),
  annualReviewsStatus: z.preprocess(emptyToUndefined, z.string().optional()),
  adverseMediaPage: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  adverseMediaSize: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  highRiskReviewPage: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  highRiskReviewSize: z.preprocess(emptyToUndefined, z.number().int().nonnegative().optional()),
  adverseMediaCompanyID: z.preprocess(companyValueToUndefined, z.number().int().nonnegative().optional()),
  highRiskReviewCompanyID: z.preprocess(companyValueToUndefined, z.number().int().nonnegative().optional())
}) as z.ZodType<Omit<AlertsPayload, 'id'>>
